var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import * as S from './style-2';
import { LPAge2To5Img, LPG1ToG2Img, LPG3ToG5Img } from '../image-cdn-urls';
import Image from '../../../components/loggedout/common/Image';
import useExtendedLocalStorage from '../../common/hooks/useExtendedLocalStorage';
import { getItemFromLocalStorage, isUKCountry } from '../../../utils/web-helper';
import { FIRST_GRADE, K_GRADE, PRE_K_GRADE, SECOND_GRADE, THIRD_GRADE, FOURTH_GRADE, FIVE_GRADE, EARLY_LEARNING_PROGRAM } from '../../../constant-data/constants';
import i18n from '../../../utils/i18n';
export var LoadThroughScreenTwo = function (props) {
    var _a;
    var childName = getItemFromLocalStorage('tutoringChildName') || '';
    var getItem = useExtendedLocalStorage('splashverse-onboarding', '').getItem;
    var selectedAge = getItem('selectedAge');
    var selectedGrade = getItem('selectedGrade');
    var selectedProgram = getItem('selectedProgram');
    var interval1;
    var interval2;
    useEffect(function () {
        (function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, new Promise(function (resolve) {
                            interval1 = setTimeout(function () {
                                var LPImage = document.querySelector('.LPScreenImage');
                                resolve();
                                if (LPImage instanceof HTMLElement) {
                                    LPImage.classList.add('scrollImage');
                                }
                                var AgeText = document.querySelector('.age-text');
                                if (AgeText instanceof HTMLElement) {
                                    AgeText.style.display = 'none';
                                }
                                interval2 = setTimeout(function () {
                                    props.goToNextHandler('load_through_screen_2', {});
                                }, 2000);
                            }, 5000);
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); })();
        return function () { return clearAllTimeouts(); };
    }, []);
    var clearAllTimeouts = function () {
        clearInterval(interval1);
        clearInterval(interval2);
    };
    var isUK = isUKCountry();
    var ageMapping = {
        '2': 'Age 2',
        '3': 'Age 3',
        '4': 'Age 4',
        '5': 'Age 5'
    };
    var gradeMapping = (_a = {},
        _a[PRE_K_GRADE] = i18n.t("loggedout-grade.pk"),
        _a[K_GRADE] = i18n.t("loggedout-grade.k"),
        _a[FIRST_GRADE] = i18n.t("loggedout-grade.1"),
        _a[SECOND_GRADE] = i18n.t("loggedout-grade.2"),
        _a[THIRD_GRADE] = i18n.t("loggedout-grade.3"),
        _a[FOURTH_GRADE] = i18n.t("loggedout-grade.4"),
        _a[FIVE_GRADE] = i18n.t("loggedout-grade.5"),
        _a);
    var ageText = selectedProgram == EARLY_LEARNING_PROGRAM ? ageMapping[selectedAge] : gradeMapping[selectedGrade];
    return (_jsxs(_Fragment, { children: [_jsx(S.Heading, { children: "Hold on, we're setting up " }), _jsxs(S.Heading, { children: [childName, "'s Learning Path..."] }), _jsx(S.LPImage, { children: _jsxs(S.Wrapper, { children: [_jsx(S.AgeText, __assign({ className: 'age-text', isLargeText: (ageText === null || ageText === void 0 ? void 0 : ageText.length) > 9 }, { children: ageText })), _jsx(Image, { className: "LPScreenImage", src: (selectedProgram == EARLY_LEARNING_PROGRAM || selectedGrade == PRE_K_GRADE || selectedGrade == K_GRADE) ? LPAge2To5Img : (((selectedGrade == FIRST_GRADE || selectedGrade == SECOND_GRADE) && !(isUK && selectedGrade == SECOND_GRADE)) ? LPG1ToG2Img : LPG3ToG5Img), alt: "lp-icon" })] }) })] }));
};
export default LoadThroughScreenTwo;
